/**
 * ⑥ 문제 등록 · ⑦ 프로젝트 종료가 「이 프로젝트가 만든 것」으로 가는 길 — 순수 함수.
 *
 * 설계: docs/ocr-hub-v2/0925_SPEC_ocr-result-links.html
 * 화면(OcrResultLinks.jsx)과 떼어 둔 이유는 판정 둘을 검사로 못박기 위해서다 —
 * 「어느 행이 ⑥ 에 번호로 서는가」와 「시험지 조회 실패가 삭제인가」.
 */

/**
 * 등록된 문제가 이보다 많으면 번호 목록을 접힌 채로 시작한다 — 버튼을 화면 밖으로 밀지 않는 선이다.
 * 실측은 설계 문서 §4 의 폭 표(1440px 에서 한 줄에 몇 개가 드는지)에 있다.
 */
export const FOLD_MAX = 40;

/**
 * OCR 문제 목록 행 → ⑥ 에 세울 번호 목록. 등록된 행만, **목록 순서 그대로**(서버가 책 순서로 준다).
 *
 * 은행에서 지워진 문제는 `promoted_problem_id` 가 null 로 온다(BE-20260830 회신 3-3).
 * 그 행을 빼지 않는다 — 빼면 머리 요약의 「등록 20/20건」과 번호 수가 어긋난다.
 * pid 를 null 로 두고, 그리는 쪽이 회색 글자 「삭제됨」으로 세운다.
 *
 * `promoted === true` 로만 가른다 — 등록 창의 단계 판정(promoteStage.splitByStage)과 같은 기준이다.
 */
export function promotedBadgeRows(items) {
  const list = Array.isArray(items) ? items : [];
  return list
    .filter((p) => p?.promoted === true)
    .map((p, i) => ({
      key: p.ocr_prob_id ?? `row-${i}`,
      pid: p.promoted_problem_id ?? null,
      index: p.problem_number ?? null,
    }));
}

/**
 * 시험지 한 장 조회의 실패를 둘로 가른다.
 *   'gone'  — 서버가 404 로 「그 시험지는 없다」고 답했다. 시험지 삭제는 숨김(soft) 처리이고 지워진 것을
 *             조회하면 404 다(BE-20260826-full-audit.md:58). 링크를 닫고 「삭제됨」이라 말해도 되는 유일한 경우.
 *   'error' — 그 밖의 전부(403·500·연결 실패·상태 코드 없는 실패). 지워졌는지 **모르므로** 링크를 남긴다.
 *             멀쩡한 시험지를 「삭제됨」이라 말하면 사람이 시험지를 새로 만드는 헛일을 한다.
 *
 * 판정은 상태 코드(`httpStatus` — utils/apiUtils 가 보존해 넘긴다) 하나로 한다.
 * 문구(message)로 가르지 않는다 — 개발 환경에서는 응답 본문이 덧붙어 문구가 달라진다.
 */
export function paperLoadOutcome(err) {
  return err?.httpStatus === 404 ? 'gone' : 'error';
}
